import { LinearProgress } from "@mui/material";
import Stack from "@mui/material/Stack";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Stepper from "@mui/material/Stepper";
import * as React from "react";

const steps = ["Waiting For Confirmation", "Transaction Submitted", "Succeed"];

type Props = {
  step: number;
};

const StepCard: React.FC<Props> = (props) => {
  const { step } = props;

  return (
    <Stack sx={{ width: "100%" }} spacing={4}>
      {step !== 2 ? (
        <LinearProgress color="secondary" />
      ) : (
        <LinearProgress variant="buffer" value={100} />
      )}

      <Stepper activeStep={step} alternativeLabel>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </Stack>
  );
};

export default StepCard;
